import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, propOr, pick } from 'ramda';

import { actions as fooActions } from 'store/newDocumentStore';

class SummaryLoader extends Component {
  componentWillMount() {
    const { dispatch, isLoading } = this.props;
    if (!isLoading) {
      dispatch(fooActions.getAllDocuments());
    }
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

SummaryLoader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};

const mapStateToProps = state => compose(pick(['isLoading', 'error']), propOr({}, 'summary'));

export default connect(mapStateToProps)(SummaryLoader);
